import React from 'react'
import { useHistory } from 'react-router'
import { generatePath } from 'react-router-dom'

import { AcornsIcon } from '@acorns/icons'

import { Etf, Portfolio } from 'generated/types'
import { routes } from 'router/routes'

type Props = {
  isProductInvest: boolean
  isProductLater: boolean
  isProductEarly: boolean
  routeParameters: { beneficiaryId: string }
  portfolio?: Portfolio
}

const usePortfolioHandlers = ({
  isProductInvest,
  isProductLater,
  isProductEarly,
  routeParameters,
  portfolio,
}: Props) => {
  const history = useHistory()

  const handleETFPress = (etf: Etf) => {
    if (isProductEarly) {
      history.push(
        `/invest/early/portfolio/${routeParameters.beneficiaryId}/fund/${etf.symbol}`,
        {
          referrer: location.pathname,
          etf,
          portfolio,
        },
      )
    } else if (isProductInvest) {
      history.push(`/invest/core/portfolio/fund/${etf.symbol}`, {
        referrer: location.pathname,
        etf,
        portfolio,
      })
    } else if (isProductLater) {
      history.push(`/invest/later/portfolio/fund/${etf.symbol}`, {
        referrer: location.pathname,
        etf,
        portfolio,
      })
    }
  }
  const handleAboutPress = () => {
    if (isProductEarly) {
      history.push(
        generatePath(routes.portfolio.aboutEarlyPortfolio, {
          beneficiaryId: routeParameters.beneficiaryId,
        }),
      )
    } else if (isProductLater) {
      history.push(routes.portfolio.aboutLaterPortfolio)
    } else if (isProductInvest) {
      history.push(routes.portfolio.aboutInvestPortfolio)
    }
  }

  const handleMobileBackPress = () => {
    if (isProductEarly) {
      history.push(
        generatePath(routes.early.details, {
          beneficiaryId: routeParameters.beneficiaryId,
        }),
      )
    } else if (isProductLater) {
      history.push(routes.later.index)
    } else if (isProductInvest) {
      history.push(routes.invest.core)
    }
  }

  const actionStripActions = [
    {
      id: 0,
      text: '',
      actionText: '',
      handler: handleAboutPress,
      icon: (
        <AcornsIcon
          icon={AcornsIcon.Icon.ProductGrow}
          width="24px"
          height="24px"
        />
      ),
    },
  ]

  return {
    handleETFPress,
    handleAboutPress,
    handleMobileBackPress,
    actionStripActions,
  }
}

export default usePortfolioHandlers
